import { Spacing, Text } from "@huub-web/ui";

export const SummaryLoading = () => (
  <>
    <Spacing height="xs" />
    <Text variant="bodyL" color="currentColor50">
      &mdash;
    </Text>
    {/* <Placeholder
      size="xs"
      width={rem(300)}
      height={rem(32)}
      variant="loading"
    /> */}
  </>
);
